import React, { FC } from 'react';

import ErrorPage from '~/shared/components/shared/ErrorPage';

const Custom404: FC = () => (
  <>
    <ErrorPage statusCode={404} />
  </>
);

export default Custom404;
